var $6bf12405fc629748$exports = {};
$6bf12405fc629748$exports = {
    "valid": `\u{6709}\u{52B9}`
};


export {$6bf12405fc629748$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
